import { useState, useRef, type MouseEvent, type ReactNode } from 'react';

interface AnimatedActionButtonProps {
  icon: ReactNode;
  title: string;
  onClick: (e: MouseEvent) => void;
  className?: string;
}

export default function AnimatedActionButton({
  icon,
  title,
  onClick,
  className = '',
}: AnimatedActionButtonProps) {
  const [animating, setAnimating] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined!);

  const handleClick = (e: MouseEvent) => {
    onClick(e);
    setAnimating(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setAnimating(false), 400);
  };

  return (
    <button
      type="button"
      title={title}
      className={`group p-1.5 rounded-full cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-600 hover:shadow-sm transition-all duration-150 ${className}`}
      onClick={handleClick}
    >
      <span
        className="inline-flex transition-transform duration-150 group-hover:scale-110 group-active:scale-95"
        style={animating ? { animation: 'action-pop 0.4s ease-out' } : undefined}
      >
        {icon}
      </span>
    </button>
  );
}
